export const DEFAULT_REFETCH_INTERVAL = 15000;
